module.exports = __webpack_public_path__ + "img/img17.8800a714.png";